"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _translationUtils = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/translationUtils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenCartButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenCartButton, _React$Component);

  function FullscreenCartButton(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.addToCart = _this.addToCart.bind(_assertThisInitialized(_this));
    _this.state = {
      buttonClassNames: 'artstore-add-to-cart-button'
    };
    return _this;
  }

  var _proto = FullscreenCartButton.prototype;

  _proto.addToCart = function addToCart() {
    if (this.props.onAddToCartRequest) {
      this.props.onAddToCartRequest();
    }
  };

  _proto.render = function render() {
    var cartItems = this.props.cartItems || [];
    var buttonClassNames = cartItems.length ? 'artstore-add-to-cart-button pro-fullscreen-checkout-link-appears' : 'artstore-add-to-cart-button has-custom-focus';
    var buttonDefaultText = _translationUtils["default"] ? _translationUtils["default"].getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : '';
    var buttonText = this.props.styleParams.addToCartButtonText || buttonDefaultText;
    return _react["default"].createElement("button", {
      className: buttonClassNames,
      tabIndex: 0,
      "aria-label": buttonText,
      onClick: this.addToCart
    }, _react["default"].createElement("div", null, buttonText), _react["default"].createElement("div", {
      className: "pro-fullscreen-overlay"
    }));
  };

  return FullscreenCartButton;
}(_react["default"].Component);

var _default = FullscreenCartButton;
exports["default"] = _default;